import {TalkViewerDataVo} from '../../common/shared/api/gateway/viewer/TalkViewerDataVo.interface';
import {TalkViewerData, ViewerDataType} from '../generated/types';
import {createTalkDownloadData} from './TalkDownloadData';

export function createTalkViewerData({
  talk_download_data,
}: TalkViewerDataVo): TalkViewerData {
  return {
    type: ViewerDataType.TalkViewerData,
    talkDownloadData: createTalkDownloadData(talk_download_data),
  };
}
